import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SelectFilter from './SelectFilter';
import { optionsPropTypes } from '../forms/select/SelectPropTypes';
import { clearErrorGettingServiceTypes, getAllServiceTypes } from '../../../actions';

const ServiceTypeFilter = ({
  serviceTypes,
  onChangeFilter,
  loading,
  dispatchGetServiceTypes,
  dispatchClearServiceTypes,
  isMulti,
  isClearable,
  placeholder,
}) => {

  useLayoutEffect(() => {
    dispatchGetServiceTypes();
    return () => dispatchClearServiceTypes();
  }, []);

  const handleChangeFilter = (selectedOptions) => {
    if (selectedOptions === null) {
      onChangeFilter([]);
      return;
    }

    if (!isMulti) {
      onChangeFilter([selectedOptions]);
    } else {
      onChangeFilter(selectedOptions);
    }
  }

  const filterOption = (options) => options;

  return (
    <SelectFilter
      isMulti={isMulti}
      isClearable={isClearable}
      isLoading={loading}
      onChangeFilter={handleChangeFilter}
      options={serviceTypes}
      placeholder={placeholder}
      filterOption={filterOption}
    />
  );
};

ServiceTypeFilter.propTypes = {
  serviceTypes: optionsPropTypes,
  onChangeFilter: PropTypes.func.isRequired,
  dispatchGetServiceTypes: PropTypes.func.isRequired,
  dispatchClearServiceTypes: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

ServiceTypeFilter.defaultProps = {
  serviceTypes: [],
  isMulti: false,
  loading: false,
  isClearable: false,
  placeholder: 'Seleccione ubicación',
};

const mapStateToProps = ({ BusUnit }) => ({
  serviceTypes: BusUnit.ServiceType.getIn(['all', 'content', 'content']).map(
    (option) => ({
      value: option.id,
      label: option.name,
    }),
  ),
  loading: BusUnit.ServiceType.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetServiceTypes: getAllServiceTypes,
  dispatchClearServiceTypes: clearErrorGettingServiceTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceTypeFilter);
